import { render, staticRenderFns } from "./GestureDetectionMetricsPanel.vue?vue&type=template&id=54b911aa&scoped=true"
import script from "./GestureDetectionMetricsPanel.vue?vue&type=script&lang=js"
export * from "./GestureDetectionMetricsPanel.vue?vue&type=script&lang=js"
import style0 from "./GestureDetectionMetricsPanel.vue?vue&type=style&index=0&id=54b911aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b911aa",
  null
  
)

export default component.exports